import type { CMSContent } from '../dto/cms.types';

export const convertCmsContent = (cmsContent: CMSContent | undefined) => {
  return (
    cmsContent?.content.EN ||
    cmsContent?.content.value
      ?.replace(/<\/?ol[^>]*>/g, '')
      ?.replace(/<li[^>]*>/g, '<p>')
      ?.replace(/<\/li>/g, '</p>')
  );
};
